import React from 'react'

export default function Code() {
    return (
        <div>
            <h1>Code</h1>

            <table>
                <tbody>
                <tr><td>React<br /></td></tr>
                <tr><td>Create react 框架 : npx create-react-app &lt;name&gt;</td></tr>
                    <tr><td>test application : npm start</td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td><br/></td></tr>
                    <tr><td>Node.js</td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td><br/></td></tr>
                    <tr><td>Git</td></tr>
                    <tr><td>git init</td></tr>
                    <tr><td>git add .</td></tr>
                    <tr><td>git commit -m "comment"</td></tr>
                    <tr><td>git log</td></tr>
                    <tr><td>git status</td></tr>
                    <tr><td>.gitignore</td></tr>
                    <tr><td>git checkout hash</td></tr>
                    <tr><td>git revert hash</td></tr>
                    <tr><td>git reset --hard hash</td></tr>
                    <tr><td>git branch #branchName</td></tr>
                    <tr><td>git branch -a //看看有什麼branch</td></tr>
                    <tr><td>git switch #branchName</td></tr>
                    <tr><td>git branch -D #branchname //刪除branch</td></tr>
                    <tr><td>git merge #branchname //從main merge branch</td></tr>
                    <tr><td>git push #gitLink #branchName</td></tr>
                    <tr><td><br/></td></tr>
                </tbody>
            </table>
        </div>
    )
}
